import { render, staticRenderFns } from "./level_rules.vue?vue&type=template&id=ce2f5cde&scoped=true"
import script from "./level_rules.vue?vue&type=script&lang=js"
export * from "./level_rules.vue?vue&type=script&lang=js"
import style0 from "./level_rules.vue?vue&type=style&index=0&id=ce2f5cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f5cde",
  null
  
)

export default component.exports